import { flatMap, get, isObject } from 'lodash';
export const resolveColorsToken = (colors, path) => get(colors, path);
export const getColorTokens = (obj, prefix = '') => {
    return flatMap(obj, (value, key) => {
        const newKey = prefix ? `${prefix}.${key}` : key;
        return isObject(value) ? getColorTokens(value, newKey) : newKey;
    });
};
//# sourceMappingURL=color-utils.js.map